// src/hooks/canvas/useLayerSync.js
//
// Layer visibility, color ve transparency senkronizasyonu.
// Tek traverse ile tum layer ozelliklerini uygular.

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as THREE from 'three';

export default function useLayerSync(scene) {
  const allLayers = useSelector(state => state.layer.allLayers || []);

  useEffect(() => {
    if (!scene || allLayers.length === 0) return;

    const layerMap = new Map();
    allLayers.forEach(layer => {
      const c = layer.color;
      let hexColor;
      if (typeof c === 'string' && c.startsWith('#')) hexColor = c;
      else if (typeof c === 'number') hexColor = '#' + c.toString(16).padStart(6, '0');
      else hexColor = '#ffffff';
      layerMap.set(layer.name, {
        visible: layer.onOff !== false,
        color: hexColor,
        transparency: layer.transparency || 0,
      });
    });

    const tempColor = new THREE.Color();

    scene.traverse((obj) => {
      const layerName = obj.userData?.layerName;
      if (!layerName) return;
      const layer = layerMap.get(layerName);
      if (!layer) return;

      obj.visible = layer.visible;

      if (obj.userData?.isColorByLayer) {
        tempColor.set(layer.color);
        if (obj.material && obj.material.color) {
          obj.material.color.copy(tempColor);
          obj.material.needsUpdate = true;
          obj.userData.originalColor = obj.material.color.getHex();
        }
        if (obj.children) {
          obj.children.forEach(child => {
            if (child.material && child.material.color && !child.material.map) {
              child.material.color.copy(tempColor);
              child.material.needsUpdate = true;
              child.userData.originalColor = child.material.color.getHex();
            }
          });
        }
        if (obj.color !== undefined && obj.text !== undefined) {
          obj.color = layer.color;
          obj.userData.originalColor = layer.color;
        }
      }

      if (obj.material) {
        const opacity = 1 - (layer.transparency / 100);
        if (opacity < 1) {
          obj.material.transparent = true;
          obj.material.opacity = opacity;
        } else {
          obj.material.transparent = false;
          obj.material.opacity = 1;
        }
        obj.material.needsUpdate = true;
      }
    });
  }, [scene, allLayers]);
}
